import "../styles/Checkout.css";
import { useEffect, useState } from "react";

const Checkout = () => {
  const [cartItems, setCartItems] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("upi");

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(cart);
  }, []);

  const originalTotal = cartItems.reduce(
    (sum, item) => sum + (item.originalPrice || item.price),
    0
  );

  const total = cartItems.reduce(
    (sum, item) => sum + item.price,
    0
  );

  const discount = originalTotal - total;

  return (
    <div className="checkout-page">

      {/* LEFT */}
      <div className="checkout-left">
        <h2>Checkout</h2>

        {/* BILLING */}
        <section className="checkout-section">
          <h3>Billing address</h3>

          <div className="row">
            <div className="field">
              <label>Country</label>
              <select>
                <option>India</option>
              </select>
            </div>

            <div className="field">
              <label>State / Union Territory</label>
              <select>
                <option>West Bengal</option>
                <option>Tamil Nadu</option>
                <option>Maharashtra</option>
                <option>Karnataka</option>
                <option>Delhi</option>
              </select>
            </div>
          </div>
        </section>

        {/* PAYMENT */}
        <section className="payment-section">
          <div className="payment-header">
            <h3>Payment method</h3>
            <span className="secure">🔒 Secure and encrypted</span>
          </div>

          {/* UPI */}
          <label className={`payment-option ${paymentMethod === "upi" ? "active" : ""}`}>
            <input
              type="radio"
              name="payment"
              checked={paymentMethod === "upi"}
              onChange={() => setPaymentMethod("upi")}
            />
            <span>UPI</span>
          </label>

          {paymentMethod === "upi" && (
            <div className="upi-box">
              <p className="upi-title">How would you like to use UPI?</p>
              <div className="upi-tabs">
                <button className="active">QR code</button>
                <button>UPI ID</button>
              </div>
              <p className="upi-text">
                Click the "Proceed" button to generate a QR code for UPI payment.
              </p>
            </div>
          )}

          {/* CARDS */}
          <label className={`payment-option ${paymentMethod === "card" ? "active" : ""}`}>
            <input
              type="radio"
              name="payment"
              checked={paymentMethod === "card"}
              onChange={() => setPaymentMethod("card")}
            />
            <span>Cards</span>
          </label>

          {paymentMethod === "card" && (
            <div className="card-box">
              <label>Card number</label>
              <input placeholder="1234 5678 9012 3456" />

              <div className="row">
                <div className="field">
                  <label>Expiry date</label>
                  <input placeholder="MM/YY" />
                </div>
                <div className="field">
                  <label>CVC / CVV</label>
                  <input placeholder="CVC" />
                </div>
              </div>

              <label>Name on card</label>
              <input placeholder="Name on card" />

              <label className="save-card">
                <input type="checkbox" />
                Securely save this card for my later purchase
              </label>
            </div>
          )}

          {/* NET BANKING */}
          <label className={`payment-option ${paymentMethod === "netbanking" ? "active" : ""}`}>
            <input
              type="radio"
              name="payment"
              checked={paymentMethod === "netbanking"}
              onChange={() => setPaymentMethod("netbanking")}
            />
            <span>Net Banking</span>
          </label>

          {paymentMethod === "netbanking" && (
            <div className="netbanking-box">
              <p className="netbanking-text">
                In order to complete your transaction, we will transfer you
                over to <strong>Adyen&apos;s</strong> secure servers.
              </p>

              <label>Bank selection</label>
              <select>
                <option value="">Select your bank</option>
                <option>SBI</option>
                <option>HDFC Bank</option>
                <option>ICICI Bank</option>
                <option>Axis Bank</option>
                <option>Kotak Mahindra</option>
              </select>
            </div>
          )}
        </section>
      </div>

      {/* RIGHT */}
      <div className="checkout-right">
        <h3>Order summary</h3>

        {cartItems.map((item, index) => (
          <div className="summary-row" key={index}>
            <span>{item.title}</span>
            <span>₹{item.price}</span>
          </div>
        ))}

        <hr />

        <div className="summary-row">
          <span>Original Price:</span>
          <span>₹{originalTotal}</span>
        </div>

        <div className="summary-row">
          <span>Discount:</span>
          <span>-₹{discount}</span>
        </div>

        <hr />

        <div className="summary-total">
          <span>Total:</span>
          <span>₹{total}</span>
        </div>

        <button className="proceed-btn">🔒 Proceed</button>
      </div>
    </div>
  );
};

export default Checkout;
